import { render } from "./CartSideBar.vue?vue&type=template&id=dc2ee4f6&scoped=true"
import script from "./CartSideBar.vue?vue&type=script&lang=js"
export * from "./CartSideBar.vue?vue&type=script&lang=js"

import "./CartSideBar.vue?vue&type=style&index=0&id=dc2ee4f6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc2ee4f6"]])

export default __exports__